// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"1ec3035d","518":"266fb054"}[chunkId] + ".chunk.js";
};